import React from 'react';
import styled from 'styled-components';
import useProfile from '../../../../../../../hooks/useProfile';
import { ButtonRequest } from '../../../IssuanceUniversityCard/info/components/Modals/styled';
import IDHelpers from '../../../../../../../../core/helpers/IDHelper';
import DateHelpers from '@/core/helpers/DateHelper';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 32px;
    gap: 16px;
  }

  .title {
    font-weight: 900;
    font-size: 20px;
    line-height: 32px;
    color: #161d1f;
    text-align: center;
  }

  .subtitle {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
    text-align: center;
    align-self: center;
  }

  .subtitleBackground {
    background-color: #000;
    color: #fff;
    padding: 3px 8px;
    font-size: 12px;
    border-radius: 4px;
    text-align: center;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 32px;
    gap: 16px;
    width: 100%;
  }

  .list__courses {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    & > ul {
      margin-left: 16px;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .list__ul {
    margin-left: 16px;
  }

  .list__ul_2 {
    margin-left: 10px;
  }

  .container__ul {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
  }

  .btn__request {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    background: #5b36f2;
    border-radius: 4px;
    width: 100%;
    height: 40px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  .cancel {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #5b36f2;
    width: 100%;
    height: 40px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;
  }

  .cancel:hover {
    background: #c6c0fc;
  }

  @media (min-width: 992px) {
    .buttons {
      flex-direction: row;
      justify-content: center;
    }
    .btn__request {
      width: 99px;
      padding: 0px;
    }
    .cancel {
      width: 87px;
      padding: 0px;
    }

    .list__ul {
      margin-left: 0px;
    }
  }
`;

const MessageEnrolment = () => (
  <>
    {new Date() <= new Date(2023, 7, 10, 23, 59, 59) ? (
      <p className="subtitleBackground">
        <b>
          Podrás matricularte nuevamente sin costo a partir del 11 de agosto.
        </b>
      </p>
    ) : (
      <></>
    )}
  </>
);

const ConfirmRequestComponent = (props: any) => {
  const {
    handlerCloseModalConfirmRequest,
    handlerSendData,
    modalityName,
    careerName,
    currentModalityName,
    selectedPeriod
  } = props;
  const { academic } = useProfile();
  const { isCGT = false } = academic;
  return (
    <Container>
      <div className="wrapper">
        <p className="title">
          ¿Deseas solicitar el Cambio de modalidad para el{' '}
          {selectedPeriod?.label?.toLowerCase()}?
        </p>
        <p className="subtitle">
          De {careerName} - {currentModalityName}.
          {isCGT && (
            <>
              <br />
              Los cursos son modulares y tienen una duración de 9 semanas.
            </>
          )}
        </p>
        <p className="subtitle">{modalityName}</p>
        {/* <ContainerMessage>
          <img src={alertTriangle} alt="alertTriangle"/>
          <div className="typography">
            Al realizar este cambio estas dejando de convalidar ## cursos. Para
            mayor información contáctate con{' '}
            <button
              className="btn__sae"
              onClick={() => history.push('/tramites/ticketera/registro')}
              type="button"
            >
              SAE
            </button>
          </div>
        </ContainerMessage> */}
      </div>
      <div className="buttons">
        <button
          data-testid="cmp-btn-ok-changemodality"
          onClick={handlerSendData}
          className="btn__request"
          type="button"
        >
          Sí, solicitar
        </button>
        <button
          data-testid="cmp-btn-cancel-changemodality"
          onClick={handlerCloseModalConfirmRequest}
          className="cancel"
          type="button"
        >
          Cancelar
        </button>
      </div>
    </Container>
  );
};

const EnrolledComponent = (props: any) => {
  const {
    handleCloseModal,
    listCourses,
    isEnrolled,
    isRequestLimit,
    isRequestLimitAndEnrollment,
    selectedPeriod
  } = props;
  const periodFormat = DateHelpers.periodToName2(selectedPeriod?.value ?? '');
  return (
    <Container data-testid="cmp-modal-isrequestlimit">
      <p className="title">Aviso importante</p>
      {isRequestLimitAndEnrollment && (
        <div className="wrapper" style={{ padding: '0px 32px 0px 47px' }}>
          <ul style={{ listStyle: 'auto' }}>
            <li>
              <p className="subtitle" style={{ textAlign: 'left' }}>
                En este momento cuentas con cursos matriculados del periodo{' '}
                {periodFormat} en tu modalidad actual, al continuar con el
                trámite, tendrás que matricularte en tu nueva modalidad destino.
                <br />
              </p>

              <div className="list__courses">
                <p style={{ marginBottom: '8px' }}>
                  Los cursos afectados son los siguientes:
                </p>
                <div className="container__ul">
                  {listCourses.map((e: any) => (
                    <ul
                      key={IDHelpers.generateID()}
                      className="list__ul_2"
                      style={{
                        listStyle: 'initial'
                      }}
                    >
                      <li> {e}</li>
                    </ul>
                  ))}
                </div>
              </div>
            </li>

            <li>
              <p
                className="subtitle"
                style={{ textAlign: 'left', marginTop: '8px' }}
              >
                Estas a punto de alcanzar el tope máximo de solicitudes
                permitidas en un mismo periodo. El % de virtualidad que
                visualizarás en cursos dentro de tu Matrícula en Línea{' '}
                {periodFormat} estará en función a la solicitud actual.
              </p>
            </li>
          </ul>
          <MessageEnrolment />
        </div>
      )}
      {isEnrolled && (
        <div className="wrapper">
          <p className="subtitle">
            En este momento cuentas con cursos matriculados del periodo{' '}
            {periodFormat} en tu modalidad actual, al continuar con el trámite,
            tendrás que matricularte en tu nueva modalidad destino.
            <br />
          </p>
          <div className="list__courses">
            <p style={{ marginBottom: '8px' }}>
              Los cursos afectados son los siguientes:
            </p>

            {listCourses.map((e: any) => (
              <ul
                key={IDHelpers.generateID()}
                className="list__ul"
                style={{
                  listStyle: 'initial'
                }}
              >
                <li> {e}</li>
              </ul>
            ))}
          </div>
          <MessageEnrolment />
        </div>
      )}
      {isRequestLimit && (
        <div className="wrapper">
          <p className="subtitle">
            Estas a punto de alcanzar el tope máximo de solicitudes permitidas
            en un mismo periodo. El % de virtualidad que visualizarás en cursos
            dentro de tu Matrícula en Línea {periodFormat} estará en función a
            la solicitud actual.
          </p>
        </div>
      )}
      <div className="buttons">
        <ButtonRequest
          data-testid="cmp-btn-request"
          style={{ margin: '0px' }}
          onClick={() => handleCloseModal()}
        >
          <p>Entendido</p>
        </ButtonRequest>
        {/* <button
          data-testid="cmp-btn-cancel-changemodality"
          onClick={() => }
          className="cancel"
          type="button"
        >
          Entendido
        </button> */}
      </div>
    </Container>
  );
};

export { ConfirmRequestComponent, EnrolledComponent };
